import REQ from '../../../utils/REQ';
import { PageBase } from './base';

export const PageNotFound = () => {
  return <PageBase req={REQ.NOT_FOUND} />;
};
